import {defineDimension, createBooleanMap} from '@webflow-platform/abilities';

export type FeatureFlagsConfig = Record<string, boolean>;
export type FeatureFlagsStores = {
  AbilityFlagsStore?: Record<string, boolean>;
};

export const featureFlagsDimension = defineDimension<
  FeatureFlagsConfig,
  FeatureFlagsStores
>()({
  key: 'featureFlags',
  isValid(state, featureFlagsToCheck) {
    // Preserve the legacy predicate exactly: a missing `AbilityFlagsStore`
    // (or a flag missing from it) reads as disabled, unlike `betaFlags`
    // which is permissive when its store is absent.
    return Object.entries(featureFlagsToCheck).every(
      ([flag, expectation]) =>
        Boolean(state.AbilityFlagsStore?.[flag]) === expectation
    );
  },
  fragments: {
    withFlagsEnabled: (...flags: string[]) => createBooleanMap(flags, true),
    withFlagsDisabled: (...flags: string[]) => createBooleanMap(flags, false),
  },
  testMatrix(addAxis, config) {
    for (const flag of Object.keys(config)) {
      addAxis((addCase) => {
        addCase({label: flag, state: {AbilityFlagsStore: {[flag]: true}}});
        addCase({
          label: `!${flag}`,
          state: {AbilityFlagsStore: {[flag]: false}},
        });
      });
    }
  },
});

export const {withFlagsEnabled, withFlagsDisabled} =
  featureFlagsDimension.fragments;
